import React, { PropsWithChildren, useContext } from 'react'
import { Breadcrumb, Breadcrumbs } from '../../../components/breadcrumbs/Breadcrumbs'
import { SecondaryPageBanner } from '../../../fragments/secondaryPageBanner'
import { GlobalContext } from '../../../globals/context'
import { isNotNull } from '../../../utils/nonNull'
import { NewsBannerFragment } from '@gql'

export type SecondaryBannerProps = NewsBannerFragment & {
  //
}

export const NewsBanner: React.FC<PropsWithChildren<SecondaryBannerProps>> = ({ title: newsTitle, uri, ...data }) => {
  const { fallback } = useContext(GlobalContext)
  const newsFallbackImage = fallback.globalSet?.__typename === 'siteSettings_GlobalSet' ? fallback.globalSet?.newsFallbackImage : undefined
  const useNewBanner = data.useNewBanner === true
  const banner = useNewBanner ? data.secondaryPageBanner?.[0] : data.newsDetailBanner?.[0]

  console.log({ useNewBanner, banner, data })

  if (!banner) {
    return null
  }

  const { title, subTitle, primaryButton, secondaryButton, image, __typename } = banner
  const subBanner = __typename === 'secondaryPageBanner_BlockType' ? banner.subBanner : []
  const bannerImage = isNotNull(image) && image.length> 0 ? image: newsFallbackImage as typeof image

  return (
    <SecondaryPageBanner
      title={title}
      subTitle={subTitle}
      primaryButton={primaryButton}
      secondaryButton={secondaryButton}
      image={bannerImage}
      after={'grey'}
      subBanner={subBanner}
      breadcrumbs={(
        <Breadcrumbs>
          <Breadcrumb href={'/'} home text={'Home'} />
          <Breadcrumb href={'/community/news'} text={'News'} />
          <Breadcrumb href={`/${uri}`} text={newsTitle || title || 'Current page'} />
        </Breadcrumbs>
      )}
    />
  )
}
